var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('org-home-stats'),_c('org-home-fee-charts'),_c('org-home-inventory-charts'),_c('org-home-retained-cases-charts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }